import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Anchor } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-maritime-primary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/gamma-logo.png" 
                alt="Gamma Marine Logo" 
                className="h-10 w-auto object-contain"
              />
              <div>
                <h3 className="text-lg font-bold">GAMMA MARINE LIMITED</h3>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              {companyInfo.tagline}
            </p>
            <div className="mt-4 pt-4 border-t border-gray-700">
              <p className="text-xs text-gray-400">
                Approved National Inspection Agency by Maritime New Zealand
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-300 hover:text-maritime-accent transition-colors duration-300"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-gray-300 hover:text-maritime-accent transition-colors duration-300"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-sm text-gray-300 hover:text-maritime-accent transition-colors duration-300"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/why-us"
                  className="text-sm text-gray-300 hover:text-maritime-accent transition-colors duration-300"
                >
                  Why Choose Us
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  className="text-sm text-gray-300 hover:text-maritime-accent transition-colors duration-300"
                >
                  Join Our Crew
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-gray-300 hover:text-maritime-accent transition-colors duration-300"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-gray-300 hover:text-maritime-accent transition-colors duration-300"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Vessel Condition Survey</li>
              <li>Lifting Gear Inspection</li>
              <li>Cargo Inspection</li>
              <li>Accident Investigation</li>
              <li>Pre-Purchase Inspections</li>
              <li>Technical Assistance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-maritime-accent flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-300">{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-maritime-accent flex-shrink-0" />
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="text-sm text-gray-300 hover:text-maritime-accent transition-colors"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-maritime-accent flex-shrink-0 mt-0.5" />
                <a
                  href={`mailto:${companyInfo.emails.operations}`}
                  className="text-sm text-gray-300 hover:text-maritime-accent transition-colors"
                >
                  {companyInfo.emails.operations}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} Gamma Marine Limited. All rights reserved.
            </p>
            <p className="text-sm text-gray-400">
              Serving {companyInfo.serviceArea}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
